// 引入模块
import axios from 'axios';
import store from '../store/index'

function JudLogin() {
    return new Promise((resolve, reject) => {
        axios
            .get('vul/hsrc/vul/report/services/user/getUserInfo')
            .then(res => {
                if (res.data && res.data.status === 200) {
                    store.commit('setUnReadBbsCount', res.data.data.unReadBbsCount)
                    store.commit('setUnReadMsgListCount', res.data.data.unReadMsgListCount)
                    store.commit('setUnReadSiteMsgCount', res.data.data.unReadSiteMsgCount)
                    if (window.sessionStorage.getItem('userId')) {
                        const userId = window.sessionStorage.getItem('userId');
                        resolve(userId);
                    } else {
                        axios
                            .get('common/hsrc/vul/common/services/jalor/web/support/workspace/current', { headers: { 'x-celon-admin': true, 'x-sub-app-id': 'hsrc_vul' } })
                            .then(res => {
                                const userId = res.data.user.userId;
                                window.sessionStorage.setItem('userId', userId);
                                resolve(userId);
                            })
                            .catch(error => {
                                reject(error);
                            });
                    }
                } else {
                    if (window.sessionStorage.getItem('userId')) {
                        window.sessionStorage.removeItem('userId');
                    }
                    resolve('noLogin');
                }
            })
            .catch(error => {
                reject(error);
            });
    });
}

export { JudLogin };



// WEBPACK FOOTER //
// ./src/axiosconfig/login.js